import { render, staticRenderFns } from "./TelemedicineNetwork.vue?vue&type=template&id=314bfd89&scoped=true&"
import script from "./TelemedicineNetwork.vue?vue&type=script&lang=js&"
export * from "./TelemedicineNetwork.vue?vue&type=script&lang=js&"
import style0 from "./TelemedicineNetwork.vue?vue&type=style&index=0&id=314bfd89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314bfd89",
  null
  
)

export default component.exports